// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"daab7eb4","143":"afcf8962","144":"35b31d9c","494":"5d337ed8","533":"d1e3c96e","651":"e4de3556","690":"9352a182","852":"636245da","940":"424a0eed"}[chunkId] + ".chunk.js";
};